import styled from "styled-components";

export const CardOptionsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`
export const LeftOptions = styled.div`
    display: flex;
    gap: 16px;
`